<div class="modal-container d-flex flex-column h-100">
  <div class="modal-header border-0 d-flex justify-content-between align-items-center">
    <div class="col-auto">
      <h1 class="modal-title text-primary-color">{{title}}</h1>
    </div>
      <div class="px-0 gap-3 col-9">
        <div class="row mx-0 align-items-center justify-content-end">
          <div class="hand col-auto">
            <label class="text-primary-color secondary-text mb-0 hand">Offer Score:
              <span [ngbTooltip]="tooltipContent" placement="bottom" tooltipClass="custom-tooltip" triggers="hover">
                {{ offerScoreResult.score }}/{{ offerScoreResult.maxScore }}
              </span>
            </label>
          </div>
          <div class="col-auto">
            <label class="textTesting secondary-text mb-0">Testing Decision<i class="fst-normal ps-1 p-0 text-danger">*</i></label>
          </div>
          <div class="col-lg-4 col-auto pe-0">
            <div class="mb-2 mb-md-0">
              <app-dropdown 
              class="testing-decision-dropdown"
               [selectLabel]="''" 
               [data]="testingDecisionList"
               [disabled]="data?.viewOffer"
               [ngClass]="{'border-red':!formModel?.testingDecisionId && submit}"
               [selectValue]="formModel?.testingDecisionId" 
               (selectValueEmit)="formModel.testingDecisionId = $event">
              </app-dropdown>
            </div>
          </div>
        </div>
      </div>
  </div>
  <div class="modal-body flex-grow-1 overflow-auto">
    <!-- <div *ngIf="data?.viewOffer" class="row mx-0 pb-3">
      <div class="col-12 px-0 d-flex gap-05">
        <div>
            <span class="d-flex font-13 text-gray">Offer Number</span>
            <span class="font-13 text-primary-color text-truncate d-block w-100">{{formModel?.offerNumber}}</span>
        </div>
        <div>
            <span class="d-flex font-13 text-gray">Date Created</span>
            <span class="font-13 text-primary-color text-truncate  d-block w-100">{{formModel?.createdAt? (formModel?.createdAt | date: 'MM/dd/yyyy') : '-'}}</span>
        </div>
        <div>
          <span class="d-flex font-13 text-gray">Created By</span>
          <span class="font-13 text-primary-color text-truncate d-block w-100">{{formModel?.createdBy? formModel?.createdBy : '-'}}</span>
      </div>
      <div>
          <span class="d-flex font-13 text-gray">Date Modified</span>
          <span class="font-13 text-primary-color text-truncate d-block w-100">{{formModel?.updatedAt? (formModel?.updatedAt | date: 'MM/dd/yyyy') : '-'}}</span>
      </div>
      <div>
        <span class="d-flex font-13 text-gray">Modified By</span>
        <span class="font-13 text-primary-color text-truncate d-block w-100">{{formModel?.updatedBy? formModel?.updatedBy  : '-'}}</span>
    </div>
      </div>
    </div> -->
      <div class="row mx-0 px-0">
        <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-4 px-0 ps-md-0 pe-md-2 pe-xl-3">
          <app-date-picker
              [time]="false"
              [inputLabel]="'Date of Offer'"
              [inputValue]="formModel?.dateOfOffer"
              (inputValueEmit)="formModel.dateOfOffer = $event"
              [adjustPopupPosition]="'bottom-left'"
              [inputReqValidation]="true"
              [ngClass]="{'border-red':!formModel?.dateOfOffer && submit}"
              [isDisabled]="offerForRFQ || data?.viewOffer"
            ></app-date-picker>
        </div>
        <div class="form-field__wrapper col-12 col-sm-6 col-md-6 col-lg-3 mb-4 px-0 ps-md-2 pe-md-0 pe-lg-2 px-xl-3">
          <label for="" [ngClass]="{ 'cursor-notAllowed opacity-50': offerForRFQ || data?.viewOffer, 'hand': !(offerForRFQ || data?.viewOffer) }" class="meta-field text-semi-primary font-14 pe-2" (click)="!(offerForRFQ || data?.viewOffer) && openAddVendorPopup()">+Add Vendor</label>
            <app-dropdown 
              [selectLabel]="'Vendor'"
              [data]="getAllDropdown?.vendorNameList"
              [selectValue]="formModel?.vendorId"
              (selectValueEmit)="onVendorChange($event)"
              [required]="true"
              [ngClass]="{'border-red':!formModel.vendorId &&  submit }"
              [disabled]="offerForRFQ || data?.viewOffer"
            >
            </app-dropdown>
        </div>
        <div class="form-field__wrapper col-12 col-sm-6 col-md-6 col-lg-3 mb-4 px-0 ps-md-0 pe-md-2 ps-lg-2 px-xl-3">
          <label for="" [ngClass]="{ 'cursor-notAllowed opacity-50': disabledContact || data?.viewOffer, 'hand': !(disabledContact || data?.viewOffer) }" class="meta-field text-semi-primary font-14 pe-2" (click)="!(disabledContact || data?.viewOffer) && openAddContactModal()">+Add Contact</label>
          <app-dropdown
          [selectLabel]="'Contact'"
          [data]="getAllDropdown?.vendorContactList"
          [selectValue]="formModel?.contactId"
          (selectValueEmit)="formModel.contactId = $event"
          [disabled]="disabledContact || data?.viewOffer"
        >
        </app-dropdown>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-4 px-0 ps-md-2 pe-md-0 ps-xl-3">
        <app-input 
        [inputLabel]="'Comments'" 
        [inputType]="'text'" 
        [inputValue]="formModel?.comments"
        (inputValueEmit)="formModel.comments = $event"
        (parentFun)="onKeydown($event, '#comments')"
        [isInputDisabled]="data?.viewOffer"
        >
        </app-input>
      </div>
      </div>
      <div class="row mx-0 custom-row-gap px-0">
      <div class="col-12 col-sm-4 col-md-6 col-lg-2 mb-2 px-0 pe-md-2 pe-xl-3">
        <app-input 
          [inputLabel]="'Qty Offered'" 
          [inputType]="'text'"
          onlyNumbers 
          [inputValue]="formModel?.qtyOffered"
          (inputValueEmit)="formModel.qtyOffered = $event"
          (parentFun)="onKeydown($event, '#qtyOffered')"
          [isInputDisabled]="data?.viewOffer"
          [ngClass]="{'border-red':!formModel?.qtyOffered &&  submit }"
          [inputReqValidation]="true">
        </app-input>
      </div>
      <div class="col-12 col-sm-4 col-md-6 col-lg-3 col-xl-2 mb-2 px-0 ps-md-2 pe-md-0 pe-lg-2 px-xl-3">
        <app-input 
          [inputLabel]="'Qty Available'" 
          [inputType]="'text'"
          onlyNumbers 
          [inputValue]="formModel?.qtyAvailable"
          [isInputDisabled]="data?.viewOffer"
          (inputValueEmit)="formModel.qtyAvailable = $event"
          (parentFun)="onKeydown($event, '#qtyAvailable')">
        </app-input>
      </div>
      <div class="col-12 col-sm-4 col-md-6 col-lg-2 mb-2 px-0 ps-md-0 pe-md-2 ps-lg-2 px-xl-3">
        <app-input 
          [inputLabel]="'Cost'" 
          [inputType]="'text'"
          onlyNumbers 
          [inputValue]="formModel?.cost"
          [isInputDisabled]="data?.viewOffer"
          [ngClass]="{'border-red':!formModel?.cost &&  submit }"
          (inputValueEmit)="formModel.cost = $event"
          (parentFun)="onKeydown($event, '#cost')"
           [inputReqValidation]="true"
          >
        </app-input>
      </div>
      <div class="col-12 col-sm-4 col-md-6 col-lg-2 mb-2 px-0 ps-md-2 pe-md-0 pe-lg-2 px-xl-3">
        <app-dropdown 
          [selectLabel]="'Currency'" 
          [data]="getAllDropdown?.currencyList"
          [selectValue]="formModel?.currency" 
          (selectValueEmit)="formModel.currency = $event"
          [required]="true"
          [ngClass]="{'border-red':!formModel?.currency &&  submit }"
          [disabled]="data?.viewOffer"

          >
        </app-dropdown>
      </div>
      <div class="col-12 col-sm-4 col-md-6 col-lg-3 col-xl-2 mb-2 px-0 ps-md-0 pe-md-2 ps-lg-2 pe-lg-0 px-xl-3">
        <app-input 
            [inputLabel]="'Exchange Rate'" 
            [inputType]="'text'" 
            onlyNumbers
            [inputValue]="formModel?.exchangeRate"
            [isInputDisabled]="data?.viewOffer"
            (inputValueEmit)="formModel.exchangeRate = $event"
            (parentFun)="onKeydown($event, '#exchangeRate')"
            >
          </app-input>
      </div>
      <div class="col-12 col-sm-4 col-md-6 col-lg-3 col-xl-2 mb-0 px-0 ps-md-2 pe-md-0 ps-lg-0 ps-xl-3 pe-md-0">
        <app-input 
          [inputLabel]="'Converted Cost'" 
          [inputType]="'text'" 
          onlyNumbers
          [inputValue]="formModel?.convertedCost"
          [isInputDisabled]="data?.viewOffer"
          (inputValueEmit)="formModel.convertedCost = $event"
          (parentFun)="onKeydown($event, '#convertedCost')"
          >
        </app-input>
      </div>  
      </div>
      <div class="row pt-4 mx-0">
        <div class="px-0">
          <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs gap-1 gap-sm-5 d-flex flex-nowrap align-items-center">
            <li *ngFor="let tab of tabData" [ngbNavItem]="tab.id" 
              [ngStyle]="{'border-bottom': active === tab.id ? '1px solid var(--sitewide_primary_accent_color)' : '1px solid transparent'}">
              <div class="hand pe-2 tab-view"
                   [ngClass]="active === tab.id ? 'text-primary-color' :  'text-light-gray'"
                    (click)="activeTab(tab.id)"
                    ngbNavLink>
                    {{ tab.label }}
              </div>
              <ng-template ngbNavContent>
                <div class="{{data?.viewOffer?'tab-content-viewwrapper':' tab-content-wrapper' }}" *ngIf="tab.id === 1">
                  <div class="row mx-0 pt-3">
                    <div class="form-field__wrapper col-12 col-sm-6 col-md-6 col-lg-2 col-xl-3 mb-4 px-0 ps-md-0 pe-md-2 pe-xl-3">
                          <label for="" [ngClass]="{ 'cursor-notAllowed opacity-50': data?.isFromSourcing || offerForRFQ || data?.viewOffer, 'hand': !(data?.isFromSourcing || offerForRFQ || data?.viewOffer) }" class="meta-field text-semi-primary font-14 pe-2" (click)="!(data?.isFromSourcing || offerForRFQ || data?.viewOffer) && openAddEditPartModal()">+Add Part</label>
                          <app-search-bar-dropdown [searchDropdown]="true" class="search-dropdown"
                            [id]="'typeahead-format1'" [name]="'MPN'" [selectLabel]="'MPN'" [inputReqValidation]="true"
                            [dataList]="getAllDropdown?.mpnList | dependentFilter : formModel?.offerDetails?.mpnId : formModel?.offerDetails?.mfrId : 'mpn': getAllDropdown?.mpnList"
                            (inputValueEmit)="selectMpnMfrValueChange($event, 'mpn')"
                             [optionDisable]="data?.isFromSourcing || offerForRFQ || data?.viewOffer"
                             [ngClass]="{'border-red':!formModel?.offerDetails?.mpnId && submit }"
                             [selectedId]="formModel?.offerDetails?.mpnId">
                          </app-search-bar-dropdown>
                    </div>
                    <div class="form-field__wrapper col-12 col-sm-6 col-md-6 col-lg-2 col-xl-3 mb-4 px-0 pe-md-0 ps-md-2 pe-lg-2 px-xl-3">
                      <label for="" [ngClass]="{ 'cursor-notAllowed opacity-50': data?.isFromSourcing || offerForRFQ || data?.viewOffer, 'hand': !(data?.isFromSourcing || offerForRFQ || data?.viewOffer) }" class="meta-field text-semi-primary font-14 pe-2" (click)="!(data?.isFromSourcing || offerForRFQ || data?.viewOffer) && openAddEditMFRModal()">+Add Mfr</label>
                      <app-search-bar-dropdown [searchDropdown]="true" class="search-dropdown"
                        [id]="'typeahead-format1'" [name]="'MFR'" [selectLabel]="'MFR'" [inputReqValidation]="true"
                        [dataList]="getAllDropdown?.masterManufacturerWithChildrenList | dependentFilter : formModel?.offerDetails?.mpnId : formModel?.offerDetails?.mfrId : 'mfr' : getAllDropdown?.mpnList"
                        (inputValueEmit)="selectMpnMfrValueChange($event, 'mfr')"
                        [optionDisable]="data?.isFromSourcing || offerForRFQ || data?.viewOffer"
                        [ngClass]="{'border-red':!formModel?.offerDetails?.mfrId && submit }"
                        [selectedId]="formModel?.offerDetails?.mfrId">
                      </app-search-bar-dropdown>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2 mb-4 px-0 ps-md-0 pe-md-2 ps-lg-2 px-xl-3">
                      <app-dropdown
                        [selectLabel]="'Date Code Year'"
                        [data]="getAllDropdown?.dcCodeYearList"
                        [selectValue]="formModel?.offerDetails?.dateCodeYearId"
                        (selectValueEmit)="formModel?.offerDetails.dateCodeYearId = $event"
                        [required]="true"
                        [ngClass]="{'border-red':!formModel?.offerDetails?.dateCodeYearId && submit }"
                        [disabled]="data?.viewOffer"
                      >
                      </app-dropdown>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2 mb-4 px-0 pe-md-0 ps-md-2 pe-lg-2 px-xl-3">
                      <app-dropdown
                        [selectLabel]="'Date Code Week'"
                        [data]="getAllDropdown?.dcCodeWeekList"
                        [selectValue]="formModel?.offerDetails?.dateCodeWeekId"
                        (selectValueEmit)="formModel?.offerDetails.dateCodeWeekId = $event"
                        [required]="true"
                         [ngClass]="{'border-red':!formModel?.offerDetails?.dateCodeWeekId && submit }"
                         [disabled]="data?.viewOffer"
                      >
                      </app-dropdown>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-2 mb-4 px-0 ps-md-0 pe-md-2 ps-lg-2 pe-lg-0 ps-xl-3">
                          <app-multiselect-dropdown
                            [listLabel]="'RoHS'"
                            [list]="getAllDropdown?.roHSList"
                            [disabled]="data?.viewOffer"
                            [checkedList]="formModel?.offerDetails?.rohsId"
                            (inputValueEmit)="inputValueEmit($event)"
                            [ngClass]="{'border-red':!formModel?.offerDetails?.rohsId && submit}"
                            [required]="true">
                          </app-multiselect-dropdown>
                    </div>
                  </div>
                  <div class="row mx-0">
                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 mb-4 px-0 ps-md-0 pe-md-2 pe-xl-3">
                            <app-input [inputLabel]="'NSN'" [isInputDisabled]="data?.viewOffer" [inputType]="'text'" [inputValue]="formModel?.offerDetails?.nsn"
                              (inputValueEmit)="formModel.offerDetails.nsn = $event">
                            </app-input>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 mb-4 px-0 pe-md-0 ps-md-2 px-lg-2 px-xl-3">
                          <app-dropdown 
                          [selectLabel]="'Condition'" 
                          [data]="getAllDropdown?.inventoryConditionsList"
                          [selectValue]="formModel?.offerDetails?.conditionId"
                           [disabled]="data?.viewOffer"
                          (selectValueEmit)="formModel.offerDetails.conditionId = $event">
                        </app-dropdown>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 mb-4 px-0 ps-md-0 pe-md-2 ps-lg-2 px-xl-3">
                            <app-dropdown
                            [selectLabel]="'Item Pkg'"
                            [data]="getAllDropdown?.standardPackagingList"
                            [ngClass]="{'border-red':!formModel.offerDetails.itemPackagingId && submit}"
                            [selectValue]="formModel?.offerDetails?.itemPackagingId"
                            (selectValueEmit)="formModel.offerDetails.itemPackagingId = $event"
                             [disabled]="data?.viewOffer"
                            [required]="true"
                            >
                            </app-dropdown>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 mb-4 px-0 pe-md-0 ps-md-2 ps-xl-3">
                      <app-multiselect-dropdown
                        [listLabel]="'COO'"
                        [list]="getAllDropdown?.countryList"
                        [checkedList]="formModel?.offerDetails?.cooId"
                        (inputValueEmit)="inputValueCOOEmit($event)"
                         [disabled]="data?.viewOffer"
                         [ngClass]="{'border-red':!formModel?.offerDetails?.cooId && submit}" 
                        [required]="true">
                      </app-multiselect-dropdown>
                    </div>
                  </div>
                  <div class="row mx-0 pb-4 custom-row-gap">
                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 mb-2 px-0 ps-md-0 pe-md-2 pe-xl-3">
                      <app-input 
                        [inputLabel]="'Description'" 
                        [inputType]="'text'" 
                        [isInputDisabled]="data?.viewOffer"
                        [inputValue]="formModel?.offerDetails?.description"
                        (inputValueEmit)="formModel.offerDetails.description = $event">
                      </app-input>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-2 mb-2 px-0 pe-md-0 ps-md-2 px-lg-2 px-xl-3">
                      <app-input 
                        [inputLabel]="'Revision'" 
                        [inputType]="'text'" 
                        [isInputDisabled]="data?.viewOffer"
                        [inputValue]="formModel?.offerDetails?.revisions"
                        (inputValueEmit)="formModel.offerDetails.revisions = $event">
                      </app-input>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-2 mb-2 px-0 ps-md-0 pe-md-2 px-lg-2 px-xl-3">
                      <app-input 
                        [inputLabel]="'Lot'" 
                        [inputType]="'text'" 
                        onlyNumbers
                        [inputValue]="formModel?.offerDetails?.lot"
                        [isInputDisabled]="data?.viewOffer"
                        (inputValueEmit)="formModel.offerDetails.lot = $event">
                      </app-input>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2 mb-2 px-0 ps-md-2 pe-md-0 px-lg-2 px-xl-3">
                      <app-input 
                        [inputLabel]="'Vendor Lead Time'" 
                        [inputType]="'text'" 
                        [isInputDisabled]="data?.viewOffer"
                        onlyNumbers
                        [inputReqValidation]="true"
                        [ngClass]="{'border-red':!formModel?.offerDetails?.vendorLeadTime && submit}"
                        [inputValue]="formModel?.offerDetails?.vendorLeadTime"
                        (inputValueEmit)="formModel.offerDetails.vendorLeadTime = $event">
                      </app-input>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-3 mb-2 px-0 pe-md-2 ps-md-0 ps-lg-2 pe-lg-0 ps-xl-3">
                     <app-dropdown 
                       [selectLabel]="'Warranty'" 
                       [required]="true"
                       [disabled]="data?.viewOffer"
                       [data]="getAllDropdown?.warrantyList"
                       [selectValue]="formModel?.offerDetails?.warranty" 
                       [ngClass]="{'border-red':!formModel?.offerDetails?.warranty && submit}"
                       (selectValueEmit)="formModel.offerDetails.warranty = $event">
                     </app-dropdown>
                    </div>
                  </div>
                </div>
                <div class="{{data?.viewOffer?'tab-content-viewwrapper':' tab-content-wrapper' }}" *ngIf="tab.id === 2">
                  <div class="row mx-0 pt-3">
                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-4 px-0 ps-md-0 pe-md-2 pe-xl-3">
                        <app-dropdown [selectLabel]="'Category Group'" [data]="getAllDropdown?.categoryGroupList"
                          [selectValue]="formModel?.partsDetails?.categoryGroupId"
                           [disabled]="data?.viewOffer"
                          (selectValueEmit)="formModel.partsDetails.categoryGroupId = $event;onChangedValue($event,enumFilterLabel?.CATEGORY_GROUP)">
                        </app-dropdown>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-4 px-0 ps-md-2 pe-md-0 px-lg-2 px-xl-3">
                        <app-dropdown [selectLabel]="'Parent Category'" [data]="getAllDropdown.parentCategoryGroupList"
                          [selectValue]="formModel?.partsDetails?.parentCategoryId"
                           [disabled]="data?.viewOffer"
                          (selectValueEmit)="formModel.partsDetails.parentCategoryId = $event;onChangedValue($event,enumFilterLabel?.PARENT_CATEGORY)"
                          [disabled]="!formModel?.partsDetails?.categoryGroupId">
                        </app-dropdown>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-4 px-0 ps-md-0 pe-md-2 px-lg-2 px-xl-3">
                        <app-dropdown [selectLabel]="'Category'" [data]="getAllDropdown?.inventoryCategoryList"
                          [selectValue]="formModel?.partsDetails?.categoryId"
                           [disabled]="data?.viewOffer"
                          (selectValueEmit)="formModel.partsDetails.categoryId = $event;onChangedValue($event,enumFilterLabel?.CATEGORY)"
                          [disabled]="!formModel?.partsDetails?.parentCategoryId">
                        </app-dropdown>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-4 pe-0 ps-md-2 px-0 ps-xl-3">
                        <app-dropdown [selectLabel]="'Sub-Category'" [data]="getAllDropdown?.subCategoryList"
                          [selectValue]="formModel?.partsDetails?.subCategoryId"
                          [disabled]="data?.viewOffer"
                          (selectValueEmit)="formModel.partsDetails.subCategoryId = $event"
                          [disabled]="!formModel?.partsDetails?.categoryId">
                        </app-dropdown>
                    </div>
                  </div>
                  <div class="row mx-0">
                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-4 px-0 ps-md-0 pe-md-2 pe-xl-3">
                      <app-input 
                        [inputLabel]="'SPQ'" 
                        [inputType]="'text'" 
                        [inputValue]="formModel?.partsDetails?.spq"
                        [isInputDisabled]="data?.viewOffer"
                        (inputValueEmit)="formModel.partsDetails.spq = $event">
                      </app-input>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-4 px-0 ps-md-2 pe-md-0 px-lg-2 px-xl-3">
                      <app-input 
                        [inputLabel]="'MOQ'" 
                        [inputType]="'text'" 
                        [isInputDisabled]="data?.viewOffer"
                        [inputValue]="formModel?.partsDetails?.moq"
                        (inputValueEmit)="formModel.partsDetails.moq = $event">
                      </app-input>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-4 px-0 ps-md-0 pe-md-2 px-lg-2 px-xl-3">
                      <app-input 
                        [inputLabel]="'HTS'" 
                        [inputType]="'text'" 
                        [isInputDisabled]="data?.viewOffer"
                        [inputValue]="formModel?.partsDetails?.hts"
                        (inputValueEmit)="formModel.partsDetails.hts = $event">
                      </app-input>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-4 px-0 ps-md-2 pe-md-0 px-xl-3">
                      <app-input 
                        [inputLabel]="'Schedule B'" 
                        [inputType]="'text'" 
                        [isInputDisabled]="data?.viewOffer"
                        [inputValue]="formModel?.partsDetails?.scheduleB"
                        (inputValueEmit)="formModel.partsDetails.scheduleB = $event">
                      </app-input>
                    </div>
                  </div>
                    <div class="row mx-0">
                      <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-4 mb-lg-0 px-0 ps-md-0 pe-md-2 pe-xl-3">
                        <app-input 
                        [inputLabel]="'ECCN'" 
                        [inputType]="'text'" 
                        [isInputDisabled]="data?.viewOffer"
                        [inputValue]="formModel?.partsDetails?.eccn"
                        (inputValueEmit)="formModel.partsDetails.eccn = $event">
                        </app-input>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-4 mb-lg-0 px-0 ps-md-2 pe-md-0 px-lg-2 px-xl-3">
                        <app-input 
                        [inputLabel]="'Temp Range'" 
                        [inputType]="'text'" 
                        [isInputDisabled]="data?.viewOffer"
                        [inputValue]="formModel?.partsDetails?.tempRange"
                        (inputValueEmit)="formModel.partsDetails.tempRange = $event">
                        </app-input>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-4 mb-lg-0 px-0 ps-md-0 pe-md-2 ps-lg-2 ps-xl-3">
                        <app-dropdown
                          [selectLabel]="'Part Status'"
                          [data]="getAllDropdown?.partStatusList"
                          [disabled]="data?.viewOffer"
                          [selectValue]="formModel?.partsDetails?.partStatus"
                          (selectValueEmit)="formModel.partsDetails.partStatus = $event"
                          [required]="false">
                        </app-dropdown>
                      </div>
                  </div>
                </div>
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav" class=""></div>
        </div>
      </div>
      <ng-container *ngIf="active === 1">
        <div>
            <div class="row mt-3 mt-lg-0 mx-0">
              <div class="col-12 px-0 trace-section mb-4">
                  <span class="secondary-text text-primary-color">Trace Details</span>
              </div>
              <div class="col-12 px-0">
                <div class="row mx-0">
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 mb-4 mb-lg-0 px-0 ps-md-0 pe-md-2 pe-xl-3">
                    <app-dropdown [selectLabel]="'Label'" [data]="labelList" [required]="true"
                      [selectValue]="formModel?.traceDetails?.labelId"
                      [disabled]="data?.viewOffer"
                      [ngClass]="{'border-red':!formModel?.traceDetails?.labelId && submit}"
                      (selectValueEmit)="onLabelChange($event)"
                      [required]="true"
                      >
                    </app-dropdown>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 mb-4 mb-lg-0 px-0 ps-md-2 pe-md-0 pe-lg-2 px-xl-3">
                    <app-dropdown [selectLabel]="'Trace Document'" [data]="traceDocumentList" [required]="false"
                      [selectValue]="formModel?.traceDetails?.traceDocument"
                      [disabled]="data?.viewOffer"
                      (selectValueEmit)="onTraceDocumentChange($event)"
                      >
                    </app-dropdown>
                  </div>
                  <div class="col-6 col-md-4 col-lg-3 col-xl-auto mb-2 mb-lg-0 px-0 ps-md-0 pe-md-2 ps-lg-2 px-xl-3">
                    <label class="text-light-info secondary-text" for="">Traceable Part</label>
                      <div class="d-flex flex-wrap column-gap-5 row-gap-2">
                        <div *ngFor="let item of traceablePartList; let i = index">
                          <app-radio-input
                            [status]="item.value === formModel?.traceDetails?.isTraceableLabel"
                            [lableName]="item.name"
                            [disabled]="data?.viewOffer"
                            [id]="'radio3_' + item.id"
                            [name]="'radioGroup3'"
                            (check)="onRadioChange(item, $event,3)">
                          </app-radio-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-4 col-lg-3 col-xl-auto mb-2 mb-lg-0 px-0 ps-md-2 pe-md-0 px-xl-3">
                   <label class="text-light-info secondary-text" for="">Recent Test Report</label>
                    <div class="d-flex flex-wrap column-gap-5 row-gap-2">
                      <div *ngFor="let item of recentTestReportList; let i = index">
                        <app-radio-input
                          [status]="item.value  ===  formModel?.traceDetails?.isRecentTraceReport"
                          [disabled]="data?.viewOffer"
                          [lableName]="item.name"
                          [id]="'radio4_' + item.id"
                          [name]="'radioGroup4'"
                          (check)="onRadioChange(item, $event,4)">
                        </app-radio-input>
                    </div>
                   </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </ng-container>
  </div>
 <div class="modal-footer border-0 justify-content-end">
    <div class="m-0 d-flex gap-3">
      <ng-container *ngIf="data?.viewOffer ; else otherCondition">
        <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button button-danger popup-button'"
          class="" (click)="activeModal.close({title,confirm:false})"
          [buttonLable]="enumButtonName.CANCEL"></app-button>
        <!-- <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button-primary button popup-button'"
          class="" [buttonLable]="'Clone'" (click)="activeModal.close({formModel: formModel,clone:true})"></app-button>
        <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button-primary button popup-button'"
          class="" [buttonLable]="'Update'" (click)="checkRequiredField() ? onClickUpdate():''"></app-button> -->
      </ng-container>
      <ng-template #otherCondition>
        <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button button-danger popup-button'"
          class="" (click)="activeModal.close({title,confirm:false})"
          [buttonLable]="enumButtonName.CANCEL"></app-button>
        <app-button [buttonType]="'button'" [button_2]="true"
          [buttonClass]="title == 'View Offer' ? 'button-info button popup-button cursor-notAllowed' : 'button-primary button popup-button'"
          [buttonLable]="'Add Offer'" (click)="title !== 'View Offer' && addOffer()"></app-button>

      </ng-template>

    </div>
  </div>